import { render, staticRenderFns } from "./OrganizationAdminDashboard.vue?vue&type=template&id=7ab7a417&"
import script from "./OrganizationAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports